import ComingSoon from "components/ComingSoon";
import React from "react";

const GoogleTag = () => {
  return <ComingSoon />;
};

export default GoogleTag;
